import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import ServerSideGrid from "../../../shared/components/listview/ServerSideGrid";
import { loadStoreCallVisitGetRequest } from "../redux/Actions";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { STORE_VISIT } from "../../../shared/constants/Constants";

const StoreVisit = ({ storeSap }) => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  const {
    storevisits: rawVisits,
    storevisitsLoading,
    storevisitsError,
  } = useSelector((state) => state.searchsap);

  const storevisits = Array.isArray(rawVisits)
    ? rawVisits
    : Array.isArray(rawVisits?.data)
    ? rawVisits.data
    : [];

  useEffect(() => {
    dispatch(loadStoreCallVisitGetRequest({ store_location_id: storeSap }));
  }, [dispatch]);

  const rowData = useMemo(() => {
    if (!storevisits?.length) return [];
    return storevisits.map((row) => {
      const location = row.locations?.[0];
      return {
        id: row.id,
        name: row.name ?? "-",
        event_type: row.event_type ?? "-",
        event_date: row.event_date ?? "-",
        status: row.status ?? "-",
        ticket_number: row.ticket_number ?? "-",   
        ticket_id: row.ticket_id ?? null, 
        vendor: row.vendor_id ?? "-",
        tracking_url: row.tracking_url ?? null,
        store: location
          ? `${location.store_sap} - ${location.store_name}`
          : "-",
        description: row.description ?? "-",
      };
    });
  }, [storevisits]);

  useEffect(() => {
    if (!storevisitsLoading && rowData.length > 0) {
      const api = gridRef.current?.getApi();
      if (api) {
        api.setFilterModel({});
      }
    }
  }, [rowData]);

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Name",
        field: "name",
        sortable: true,
        width: 180,
      },
      {
        headerName: "Ticket ID",
        field: "ticket_number",
        width: 140,
        pinned: true,
        cellRenderer: (params) => params.data?.ticket_id ? (
                        <a href={`/ticketing/${params.data.ticket_id}`}>{params.value}</a>
                      ) : params.value,
      },
      {
        headerName: "Event Type",
        field: "event_type",
        sortable: true,
        width: 160,
      },
            {
        headerName: "Vendor",
        field: "vendor",
        sortable: true,
        width: 180,
      },
      {
        headerName: "Tracking URL",
        field: "tracking_url",
        width: 160,
        cellRenderer: (params) =>
          params.value ? (
            <a href={params.value} target="_blank" rel="noreferrer">Track</a>
          ) : "-",
      },
      {
        headerName: "Event Date",
        field: "event_date",
        sortable: true,
        width: 160,
      },
      {
        headerName: "Status",
        field: "status",
        sortable: true,
        width: 130,
        cellRenderer: (params) => {
          const val = params.value?.toLowerCase();
          const cls =
            val === "completed"
              ? "badge bg-success"
              : val === "pending"
              ? "badge bg-warning text-dark"
              : "badge bg-secondary";
          return <span className={cls}>{params.value}</span>;
        },
      },
      {
        headerName: "Store",
        field: "store",
        sortable: true,
        width: 260,
      },
      {
        headerName: "Description",
        field: "description",
        sortable: true,
        flex: 1,
        minWidth: 200,
      },
    ],
    []
  );

  if (storevisitsError) {
    return (
      <div className="alert alert-danger mt-3" role="alert">
        {storevisitsError?.msg || "Failed to load store visits."}
      </div>
    );
  }

  return (
    <>
    <Row>
        <Col>
            <Breadcrumbs
                children={[
                    { label: STORE_VISIT },
                ]}
            />
        </Col>
    </Row>
    <Row>
      <Card className="table-card">
        <Card.Body>
          <ServerSideGrid
            ref={gridRef}
            clientSide={true}
            rowData={rowData}
            loading={storevisitsLoading}
            columnDefs={columnDefs}
            // tableHeight="60vh"
            showPagination={true}
            paginationPageSize={20}
            theme="alpine"
          />
        </Card.Body>
      </Card>
    </Row>
    </>
  );
};

export default StoreVisit;